module.exports = __webpack_public_path__ + "img/chat_background.3f599ec1.png";